import React from "react";
import { Button, Col, Row, Table } from "reactstrap";
import MainService from "../../../../Services/MainService";

export default function LevelTwoRequirements(props) {
  const { data, setZoomImagePath } = props;

  const viewProof = path => {
    if (!path) {
      return false;
    }
    if (MainService.getFxtensions(path) === "image") {
      setZoomImagePath(path);
    } else {
      window.open(path, "_blank");
    }
  };

  return (
    <Col sm={12}>
      <Row>
        <Col sm={6}>
          <Table bordered striped responsive className="mb-0">
            <tbody>
              <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className={"text-capitalize"}>
                  Legal Business Name
                </th>
                <td className="w-50">{data.levelTwo.legalBusinessName}</td>
              </tr>
              <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className={"text-capitalize"}>
                  Business Incorporation/Registration Number
                </th>
                <td className="w-50">
                  {data.levelTwo.businessRegistrationNumber}
                </td>
              </tr>
              <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className={"text-capitalize"}>
                  Business Registration Address
                </th>
                <td className="w-50">
                  {data.levelTwo.businessRegisteredAddress}
                </td>
              </tr>
              <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className={"text-capitalize"}>
                  Business Registration Certificate Proof
                </th>
                <td className="w-50">
                  {!data.levelTwo.businessRegistrationCertificateFile ? (
                    <span className="text-danger">No attached file yet</span>
                  ) : (
                    <Button
                      color="primary"
                      size="sm"
                      onClick={() => {
                        viewProof(
                          data.levelTwo.businessRegistrationCertificateFile
                            .filePath,
                        );
                      }}>
                      View Proof
                    </Button>
                  )}
                </td>
              </tr>
              <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className={"text-capitalize"}>
                  Business Registration Address Proof
                </th>
                <td className="w-50">
                  {!data.levelTwo.businessRegisteredAddressFile ? (
                    <span className="text-danger">No attached file yet</span>
                  ) : (
                    <Button
                      color="primary"
                      size="sm"
                      onClick={() => {
                        viewProof(
                          data.levelTwo.businessRegisteredAddressFile.filePath,
                        );
                      }}>
                      View Proof
                    </Button>
                  )}
                </td>
              </tr>
            </tbody>
          </Table>
        </Col>
        <Col sm={6}>
          <Table bordered striped responsive className="mb-0">
            <tbody>
              {/* <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className={"text-capitalize"}
                >
                  Regulatory Licensing Number:
                </th>
                <td className='w-50'>{data.levelTwo.primaryRegulatoryLicencingNumber}</td>
              </tr> */}
              <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className={"text-capitalize"}>
                  Country of Incorporation/Registration
                </th>
                <td className="w-50">
                  {data.levelTwo.businessCountryOfRegistration}
                </td>
              </tr>
              {/* <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className={"text-capitalize"}
                >
                  {`API Key (OTC -> Agent)`}
                </th>
                <td className='w-50'>{data.levelTwo.apiKey_1}</td>
              </tr>
              <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className={"text-capitalize"}
                >
                  {`API Key (Agent -> Agent)`}
                </th>
                <td className='w-50'>{data.levelTwo.apiKey_2}</td>
              </tr> */}
              <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className={"text-capitalize"}>
                  Certificate of Incorporation/Incumbency
                </th>
                <td className="w-50">
                  {!data.levelTwo.certificateOfIncumbencyFile ? (
                    <span className="text-danger">No attached file yet</span>
                  ) : (
                    <Button
                      color="primary"
                      size="sm"
                      onClick={() => {
                        viewProof(
                          data.levelTwo.certificateOfIncumbencyFile.filePath,
                        );
                      }}>
                      View Proof
                    </Button>
                  )}
                </td>
              </tr>
              <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className={"text-capitalize"}>
                  Merchant Services Agreement
                </th>
                <td className="w-50">
                  {!data.levelTwo.certificateOfIncorporationFile ? (
                    <span className="text-danger">No attached file yet</span>
                  ) : (
                    <Button
                      color="primary"
                      size="sm"
                      onClick={() => {
                        viewProof(
                          data.levelTwo.certificateOfIncorporationFile.filePath,
                        );
                      }}>
                      View Proof
                    </Button>
                  )}
                </td>
              </tr>
              {/* <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className={"text-capitalize"}
                >
                  Other Proof Of Business
                </th>
                <td className='w-50'>
                  {
                    !data.levelTwo.otherProofFile ? <span className='text-danger'>No attached file yet</span> :
                      <Button
                        color="primary"
                        size="sm"
                        onClick={() => {
                          viewProof(data.levelTwo.otherProofFile.filePath)
                        }}
                      >
                        View Proof
                      </Button>
                  }
                </td>
              </tr> */}
            </tbody>
          </Table>
        </Col>
        {/* <Col sm={12} className='mt-3'>
          <Table bordered responsive className='mb-0'>
            <tbody>
              <tr>
                <th
                  scope="row"
                  style={{ width: "400px" }}
                  className={"text-capitalize"}
                >
                  Primary Regulatory Licenses (if applicable)
                </th>
                <td className='w-50'>

                  {
                    data.levelTwo.businessRegulatoryLicencingNumberFile && data.levelTwo.businessRegulatoryLicencingNumberFile.length ?
                      <div className='w-100'>
                        <div className='w-100 overflowY-scroll' style={{ maxHeight: "calc(200px + 1rem)", overflowX: "hidden" }}>
                          <div className='d-flex flex-wrap'>
                            {
                              data.levelTwo.businessRegulatoryLicencingNumberFile.map((item, index) => {
                                return <div key={index} className='position-relative border rounded' style={{ maxWidth: "150px", maxHeight: "150px", minHeight: "100px", minWidth: "100px", margin: "5px" }}>
                                  {
                                    (() => {
                                      switch (MainService.getFxtensions(item.filePath)) {
                                        case "image":
                                          return <div
                                            style={{ width: "100%", height: "100%", }}
                                            className='d-flex justify-content-center align-items-center flex-column cursor-pointer'
                                            onClick={() => setZoomImagePath(item.filePath)}
                                          >
                                            <img
                                              src={item.filePath}
                                              className='rounded'
                                              style={{ maxWidth: "200px", width: "100%", height: "100%", maxHeight: "200px" }}
                                              alt='/'
                                            />
                                          </div>
                                        case "file":
                                          return <div
                                            style={{ width: "100%", height: "100%", }}
                                            className='p-2  d-flex justify-content-center align-items-center flex-column cursor-pointer'
                                            onClick={() => window.open(item.filePath, "_blank")}
                                          >
                                            <i className='bx bx-file-blank' style={{ fontSize: "50px" }} ></i>
                                          </div>
                                        default:
                                          break;
                                      }
                                    })()
                                  }

                                </div>
                              })
                            }
                          </div>
                        </div>

                      </div>
                      : <span className='text-danger'>No attached file(s) yet</span>
                  }
                </td>
              </tr>
            </tbody>
          </Table>
        </Col> */}
      </Row>
    </Col>
  );
}
